module.exports = __webpack_public_path__ + "img/icon-users-active.100b2932.svg";